module.exports = __webpack_public_path__ + "static/img/pic_news3.c89a60c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/news/pic_news3.jpg
// module id = WZYG
// module chunks = 0